import Hero from "@/components/site/Hero";
import ProblemSection from "@/components/site/ProblemSection";
import InduceXTSpotlight from "@/components/site/InduceXTSpotlight";
import ProductComparison from "@/components/site/ProductComparison";
import InduceXTResources from "@/components/site/InduceXTResources";
import JoinSection from "@/components/site/JoinSection";
import FinalCTA from "@/components/site/FinalCTA";

export default function HomePage() {
    return (
        <div data-testid="home-page">
            <Hero />
            <ProblemSection />
            <InduceXTSpotlight />
            <ProductComparison />
            <InduceXTResources />
            <JoinSection />
            <FinalCTA />
        </div>
    );
}
